export default class ForbiddenErrorResponse extends Error {
  constructor(response: Response) {
    super(`ForbiddenErrorResponse: ${response.status} ${response.statusText}`);
  }
}
